import { BaseButton } from "../Button/BaseButton.tsx";
import { versionBannerStore } from "./versionBannerStore.ts";

export const VersionBanner = () => {
  const { showVersionBanner } = versionBannerStore.useState();
  return (
    showVersionBanner && (
      <div className="h-[40px] w-full flex-row items-center px-600 bg-surface-emphasis-primary-rest text-emphasis-primary label-md-default">
        <div className="flex-row items-center">
          New version available. Please&nbsp;
          <BaseButton
            className="label-md-semibold underline"
            onClick={() => window.location.reload()}
          >
            refresh the page
          </BaseButton>
          &nbsp;to avoid potential errors.
        </div>
      </div>
    )
  );
};
